<template>
  <div class="drawMoneyTips">
    <div class="mark"></div>
    <div class="content">
      <div class="title">温馨提示</div>
      <div class="text">1、若您采用受托支付的方式进行贷款支用，审批成功后，所支用金额将发放至您在亿联银行个人II类户后受托支付至您本支用指定的收款对公账户中。
<br />2、如选择受托支付，您可根据自身需要添加附言通知收款方。</div>
      <div class="btn" @click="onOk">我已知晓</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['changeTipsShow'],
  methods: {
    onOk() {
      this.changeTipsShow(false)
    }
  }
}
</script>

<style scoped lang="scss">
  .drawMoneyTips {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    .mark {
      position: absolute;
      z-index: -1;
      width: 100%;
      height: 100%;
      background: rgba(0,0,0,0.40);
    }
    .content {
      width: 303px;
      height: 254px;
      background: #FFFFFF;
      border-radius: 8px;
      .title {
        font-family: PingFangSC-Medium;
        font-size: 18px;
        color: #001F33;
        letter-spacing: 0;
        font-weight: 500;
        height: 50px;
        line-height: 50px;
        text-align: left;
        padding-left: 16px;
        border-bottom: 1px solid #E9F0F5;;
      }
      .text {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #495060;
        letter-spacing: 0;
        font-weight: 400;
        padding: 16px 28px 12px 20px;
        text-align: left;
      }
      .btn {
        width: 279px;
        height: 44px;
        margin: 0 auto;
        background: #DC3131;
        border-radius: 4px;
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #FFFFFF;
        letter-spacing: 0;
        text-align: center;
        font-weight: 400;
        line-height: 44px;
      }
    }
  }
</style>